import React, { useState } from 'react'
import { Tooltip } from 'antd'
import styled from 'styled-components'
import { Flex, icons, ColourButton } from 'portal/lib/primitives'
import { colours, sizes } from '@qflow/theme'

interface OnlyFlaggedDesignMatchesFilterProps {
  onToggle: (newState: string) => void
}

export function OnlyFlaggedDesignMatchesFilter({
  onToggle
}: OnlyFlaggedDesignMatchesFilterProps) {
  const [onlyShowFlaggedDesignMatches, setOnlyShowFlaggedDesignMatches] =
    useState<string | null>(
      localStorage.getItem('only-flagged-design-matches-filter')
    )

  const toggleFilter = () => {
    const newState =
      !onlyShowFlaggedDesignMatches || onlyShowFlaggedDesignMatches === 'false'
        ? 'true'
        : 'false'
    setOnlyShowFlaggedDesignMatches(newState)
    localStorage.setItem('only-flagged-design-matches-filter', newState)
    onToggle(newState)
  }

  return (
    <ButtonContainer>
      <FilterButton
        id="OnlyFlaggedDesignMatchesFilter"
        onClick={toggleFilter}
        $onlyShowFlaggedDesignMatches={onlyShowFlaggedDesignMatches}
      >
        <Tooltip
          title={
            onlyShowFlaggedDesignMatches === 'true'
              ? 'Only showing records with flagged design matches'
              : 'Only show records with flagged design matches'
          }
        >
          <span>
            <icons.DesignMatch size={sizes.SMALL} /> Only Flagged
          </span>
        </Tooltip>
      </FilterButton>
    </ButtonContainer>
  )
}

const ButtonContainer = styled(Flex.Col)`
  flex: 0 0 auto;
  align-items: flex-end;
`

const FilterButton = styled(ColourButton.Basic)<{
  $onlyShowFlaggedDesignMatches: string | null
}>`
  border-radius: 25px;
  color: ${({ $onlyShowFlaggedDesignMatches }) =>
    $onlyShowFlaggedDesignMatches === 'true'
      ? colours.ORANGE
      : colours.DARK_GREY};
  background-color: ${({ $onlyShowFlaggedDesignMatches }) =>
    $onlyShowFlaggedDesignMatches === 'true' ? '#FFF2EB' : colours.WHITE};
  border-color: ${({ $onlyShowFlaggedDesignMatches }) =>
    $onlyShowFlaggedDesignMatches === 'true'
      ? colours.ORANGE
      : colours.BORDER_GREY};

  &:hover {
    background: transparent;
    color: ${({ $onlyShowFlaggedDesignMatches }) =>
      $onlyShowFlaggedDesignMatches === 'true'
        ? colours.ORANGE
        : colours.DARK_GREY};
    border-color: ${({ $onlyShowFlaggedDesignMatches }) =>
      $onlyShowFlaggedDesignMatches === 'true'
        ? colours.ORANGE
        : colours.DARK_GREY};
  }

  &:focus {
    color: ${({ $onlyShowFlaggedDesignMatches }) =>
      $onlyShowFlaggedDesignMatches === 'true'
        ? colours.ORANGE
        : colours.DARK_GREY};
    background-color: ${({ $onlyShowFlaggedDesignMatches }) =>
      $onlyShowFlaggedDesignMatches === 'true' ? '#FFF2EB' : colours.WHITE};
  }

  &:hover:focus {
    background: transparent;
  }

  > SVG {
    color: ${({ $onlyShowFlaggedDesignMatches }) =>
      $onlyShowFlaggedDesignMatches === 'true'
        ? colours.ORANGE
        : colours.BATTLESHIP_GREY};
  }

  &:hover > SVG {
    color: ${({ $onlyShowFlaggedDesignMatches }) =>
      $onlyShowFlaggedDesignMatches === 'true'
        ? colours.ORANGE
        : colours.CHARCOAL_GREY};
  }
`
